webpackJsonp([69],{

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".Table3 .table{display:table;border-collapse:collapse;width:100%}.Table3 .td,.Table3 .th{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.Table3 a{text-decoration:underline}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/Table3/src/components/contents/Table3/Table3.s.scss"],"names":[],"mappings":"AAEA,eAEI,cAAc,AACd,yBAAyB,AACzB,UAAW,CACZ,AALH,wBAQI,sBAAsB,AACtB,kBAAkB,AAClB,cAAc,AACd,eAAmB,CACpB,AAZH,UAcI,yBAA0B,CAC3B","file":"Table3.s.scss","sourcesContent":["@import '~scss/variables';\n\n.Table3 {\n  .table {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n  }\n  .th,\n  .td {\n    border: 1px solid #999;\n    text-align: center;\n    font-size: 1em;\n    font-weight: normal;\n  }\n  a {\n    text-decoration: underline;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1196);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("6081f0e7", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/69.55eacf2cc4b60759a9cc.js